'use client';

import Link from '@eliadmin/core/src/components/link';

import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export function HeroBar({ title }: { title: string }) {
  const me = useCustomerStore(s => s.me);
  const isInitialized = useCustomerStore(s => s.isInitialized);

  const isLoggedIn = isInitialized && !!me;

  if (!isLoggedIn)
    return (
      <section className={cn('custom-section', 'primary-gradient', 'p-6')}>
        <div
          className={cn(
            'custom-container',
            'flex flex-col items-center justify-center gap-4 sm:flex-row sm:items-center sm:justify-between',
          )}
        >
          <HtmlRendererRaw
            as="p"
            className="w-full text-center text-lg font-bold text-white sm:w-fit sm:text-left lg:text-xl"
            html={title}
          />
          <Button asChild variant={'white'} className="w-full whitespace-nowrap sm:w-fit">
            <Link prefetch={false} href={'/pre-uchadzaca'}>
              Vytvoriť profil
            </Link>
          </Button>
        </div>
      </section>
    );
}
